import { render } from "./RequestModal.vue?vue&type=template&id=1ba9395d"
import script from "./RequestModal.vue?vue&type=script&lang=js"
export * from "./RequestModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__